/** Help §5.3 — Connect your Outlook (`admin/OutlookConnect.tsx`, `shell/Sidebar.tsx`). */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, Callout, HelpSectionCard, Li, Shot, Steps } from '../HelpPrimitives.js';

export function Outlook(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('outlook')}>
      <Steps>
        <Li>
          At the bottom of the sidebar, click <Btn>Connect Outlook</Btn>.
        </Li>
        <Li>A Microsoft sign-in window opens — sign in and accept.</Li>
        <Li>
          You’ll see <Btn>Connected</Btn> once it’s done.
        </Li>
      </Steps>
      <Shot
        slug="outlook-sidebar"
        caption="The bottom of the sidebar — Connect Outlook (it reads Connected once linked), Help and Log out."
      />
      <Callout title="Later">
        A <Btn>Disconnect</Btn> button lets you unlink the mailbox — it asks{' '}
        <em>“Disconnect Outlook?”</em> first.
      </Callout>
    </HelpSectionCard>
  );
}
